module.exports = __webpack_public_path__ + "media/img/favicon/apple-touch-icon-e50b5bd94dd4e1748139b0240aeb1fc3.png";